import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Button, Loading } from 'src/shared/index';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@apollo/client';
import { handleApiError } from 'src/shared/utils/handleApiError';
import { SubscriptionFormFields } from './subsciption-form-fields';
import { UPDATE_ACCOUNT_SUB } from '../graphql/update-account-subscription.mutation';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const accountSubscriptionFormFieldsSchema = {
  franchisesOptIn: Yup.array().of(
    Yup.object().shape({
      id: Yup.string().required(),
      name: Yup.string().required(),
      classNotification: Yup.boolean(),
      newsOrAnnouncement: Yup.boolean(),
      emailNewsOrAnnouncement: Yup.boolean(),
    }),
  ),
};
const schema = Yup.object().shape(accountSubscriptionFormFieldsSchema);

export const AccountSubscriptionFormFields = ({
  isLoading,
  defaultValues,
  account,
}) => {
  const { id } = useParams();
  const formMethods = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { handleSubmit, setError } = formMethods;
  const [mutate, { loading }] = useMutation(UPDATE_ACCOUNT_SUB);
  const onSubmit = async (values) => {
    const formattedValues = {
      franchisesOptIn:
        values.franchisesOptIn?.length > 0
          ? values.franchisesOptIn.map((franchise) => ({
              id: franchise.id,
              classNotification: franchise.classNotification,
              newsOrAnnouncement: franchise.newsOrAnnouncement,
              emailNewsOrAnnouncement: franchise.emailNewsOrAnnouncement,
              emailClassNotification: true,
            }))
          : [],
    };
    try {
      await mutate({
        variables: {
          input: {
            id: account.id,
            hash: id,
            ...formattedValues,
          },
        },
      });
      toast.success('Subscriptions updated successfully');
    } catch (error) {
      handleApiError(error, setError);
    }
  };
  return (
    <>
      {loading && <Loading className="absolute" />}
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormProvider {...formMethods}>
          <SubscriptionFormFields />
        </FormProvider>
        <div className="flex justify-end">
          <Button
            type="submit"
            $loading={loading || isLoading}
            $loadingText="Updating..."
          >
            Update Subscriptions
          </Button>
        </div>
      </form>
    </>
  );
};
